import {CSSProperties} from "react";
import {ColorRing} from "react-loader-spinner";

interface SpinnerLoaderProps {
  size?: number;
  style?: CSSProperties;
}

export const SpinnerLoader: React.FC<SpinnerLoaderProps> = ({
  size = 50,
  style,
}) => {
  return <ColorRing width={size} height={size} wrapperStyle={style as any} />;
};
